import React from "react";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { SanctionsList } from "../../../services/api/sanctions/SanctionsApiService";
import { SanctionsListItemProps } from "./types";
import { CircleHelp } from "lucide-react";


export const SanctionsListItem: React.FC<SanctionsListItemProps> = ({
    list,
    isChecked,
    onCheckboxChange,
    onInfoClick
}) => {
    return (
        <div className="flex flex-col md:flex-row items-center py-3 px-3 mb-2 bg-white dark:bg-neutral-900 rounded-md border border-neutral-200 dark:border-neutral-800 transition-all duration-300 shadow-sm animate-slideInUp hover:-translate-y-0.5 hover:shadow-md hover:border-indigo-500 last:mb-0 gap-4 md:gap-0 text-center md:text-left">
            <div className="mr-0 md:mr-3 [&_.p-checkbox_.p-checkbox-box]:w-[18px] [&_.p-checkbox_.p-checkbox-box]:h-[18px] [&_.p-checkbox_.p-checkbox-box]:rounded [&_.p-checkbox_.p-checkbox-box]:border-2 [&_.p-checkbox_.p-checkbox-box]:border-indigo-500 [&_.p-checkbox_.p-checkbox-box]:transition-all [&_.p-checkbox_.p-checkbox-box]:duration-300 [&_.p-checkbox_.p-checkbox-box.p-highlight]:bg-indigo-500 [&_.p-checkbox_.p-checkbox-box.p-highlight]:border-indigo-500">
                <Checkbox
                    inputId={list.id}
                    checked={isChecked}
                    onChange={(e) => onCheckboxChange(list.id, e.checked || false)}
                />
            </div>
            <label htmlFor={list.id} className="flex-1 font-medium text-neutral-700 dark:text-neutral-300 m-0 text-sm text-left">
                {list.name}
            </label>
            <Button
                icon={<CircleHelp size={16} />}
                className="bg-indigo-500 border-0 text-white w-7 h-7 rounded-full flex items-center justify-center transition-all duration-300 shadow-sm hover:bg-indigo-600 hover:scale-105 hover:shadow-md [&_.p-button-icon]:text-xs"
                onClick={() => onInfoClick(list.data)}
                tooltip="View list details"
            />
        </div>
    );
};
